// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/capability/v1/capability.proto (package mono.capability.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * CapabilityType categorizes extracted capabilities.
 *
 * @generated from enum mono.capability.v1.CapabilityType
 */ export var CapabilityType = /*#__PURE__*/ function(CapabilityType) {
    /**
   * @generated from enum value: CAPABILITY_TYPE_UNSPECIFIED = 0;
   */ CapabilityType[CapabilityType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CAPABILITY_TYPE_TECHNICAL = 1;
   */ CapabilityType[CapabilityType["TECHNICAL"] = 1] = "TECHNICAL";
    /**
   * @generated from enum value: CAPABILITY_TYPE_PAST_PERFORMANCE = 2;
   */ CapabilityType[CapabilityType["PAST_PERFORMANCE"] = 2] = "PAST_PERFORMANCE";
    /**
   * @generated from enum value: CAPABILITY_TYPE_PERSONNEL = 3;
   */ CapabilityType[CapabilityType["PERSONNEL"] = 3] = "PERSONNEL";
    /**
   * @generated from enum value: CAPABILITY_TYPE_CERTIFICATION = 4;
   */ CapabilityType[CapabilityType["CERTIFICATION"] = 4] = "CERTIFICATION";
    return CapabilityType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(CapabilityType)
proto3.util.setEnumType(CapabilityType, "mono.capability.v1.CapabilityType", [
    {
        no: 0,
        name: "CAPABILITY_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CAPABILITY_TYPE_TECHNICAL"
    },
    {
        no: 2,
        name: "CAPABILITY_TYPE_PAST_PERFORMANCE"
    },
    {
        no: 3,
        name: "CAPABILITY_TYPE_PERSONNEL"
    },
    {
        no: 4,
        name: "CAPABILITY_TYPE_CERTIFICATION"
    }
]);
/**
 * FeedbackRating represents a user's assessment of match quality.
 *
 * @generated from enum mono.capability.v1.FeedbackRating
 */ export var FeedbackRating = /*#__PURE__*/ function(FeedbackRating) {
    /**
   * @generated from enum value: FEEDBACK_RATING_UNSPECIFIED = 0;
   */ FeedbackRating[FeedbackRating["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: FEEDBACK_RATING_HELPFUL = 1;
   */ FeedbackRating[FeedbackRating["HELPFUL"] = 1] = "HELPFUL";
    /**
   * @generated from enum value: FEEDBACK_RATING_NOT_HELPFUL = 2;
   */ FeedbackRating[FeedbackRating["NOT_HELPFUL"] = 2] = "NOT_HELPFUL";
    /**
   * @generated from enum value: FEEDBACK_RATING_IRRELEVANT = 3;
   */ FeedbackRating[FeedbackRating["IRRELEVANT"] = 3] = "IRRELEVANT";
    return FeedbackRating;
}({});
// Retrieve enum metadata with: proto3.getEnumType(FeedbackRating)
proto3.util.setEnumType(FeedbackRating, "mono.capability.v1.FeedbackRating", [
    {
        no: 0,
        name: "FEEDBACK_RATING_UNSPECIFIED"
    },
    {
        no: 1,
        name: "FEEDBACK_RATING_HELPFUL"
    },
    {
        no: 2,
        name: "FEEDBACK_RATING_NOT_HELPFUL"
    },
    {
        no: 3,
        name: "FEEDBACK_RATING_IRRELEVANT"
    }
]);
/**
 * ExtractionStatus indicates the outcome of a capability extraction.
 *
 * @generated from enum mono.capability.v1.ExtractionStatus
 */ export var ExtractionStatus = /*#__PURE__*/ function(ExtractionStatus) {
    /**
   * @generated from enum value: EXTRACTION_STATUS_UNSPECIFIED = 0;
   */ ExtractionStatus[ExtractionStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXTRACTION_STATUS_SUCCESS = 1;
   */ ExtractionStatus[ExtractionStatus["SUCCESS"] = 1] = "SUCCESS";
    /**
   * @generated from enum value: EXTRACTION_STATUS_FAILURE = 2;
   */ ExtractionStatus[ExtractionStatus["FAILURE"] = 2] = "FAILURE";
    /**
   * @generated from enum value: EXTRACTION_STATUS_LOW_CONFIDENCE = 3;
   */ ExtractionStatus[ExtractionStatus["LOW_CONFIDENCE"] = 3] = "LOW_CONFIDENCE";
    return ExtractionStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExtractionStatus)
proto3.util.setEnumType(ExtractionStatus, "mono.capability.v1.ExtractionStatus", [
    {
        no: 0,
        name: "EXTRACTION_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXTRACTION_STATUS_SUCCESS"
    },
    {
        no: 2,
        name: "EXTRACTION_STATUS_FAILURE"
    },
    {
        no: 3,
        name: "EXTRACTION_STATUS_LOW_CONFIDENCE"
    }
]);
/**
 * ObligationStrength indicates how strongly a requirement is mandated.
 *
 * @generated from enum mono.capability.v1.ObligationStrength
 */ export var ObligationStrength = /*#__PURE__*/ function(ObligationStrength) {
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_UNSPECIFIED = 0;
   */ ObligationStrength[ObligationStrength["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_MUST = 1;
   */ ObligationStrength[ObligationStrength["MUST"] = 1] = "MUST";
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_SHOULD = 2;
   */ ObligationStrength[ObligationStrength["SHOULD"] = 2] = "SHOULD";
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_MAY = 3;
   */ ObligationStrength[ObligationStrength["MAY"] = 3] = "MAY";
    return ObligationStrength;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ObligationStrength)
proto3.util.setEnumType(ObligationStrength, "mono.capability.v1.ObligationStrength", [
    {
        no: 0,
        name: "OBLIGATION_STRENGTH_UNSPECIFIED"
    },
    {
        no: 1,
        name: "OBLIGATION_STRENGTH_MUST"
    },
    {
        no: 2,
        name: "OBLIGATION_STRENGTH_SHOULD"
    },
    {
        no: 3,
        name: "OBLIGATION_STRENGTH_MAY"
    }
]);
/**
 * ExtractionErrorType categorizes extraction failures.
 *
 * @generated from enum mono.capability.v1.ExtractionErrorType
 */ export var ExtractionErrorType = /*#__PURE__*/ function(ExtractionErrorType) {
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_UNSPECIFIED = 0;
   */ ExtractionErrorType[ExtractionErrorType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_LLM = 1;
   */ ExtractionErrorType[ExtractionErrorType["LLM"] = 1] = "LLM";
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_TIMEOUT = 2;
   */ ExtractionErrorType[ExtractionErrorType["TIMEOUT"] = 2] = "TIMEOUT";
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_INVALID_DOCUMENT = 3;
   */ ExtractionErrorType[ExtractionErrorType["INVALID_DOCUMENT"] = 3] = "INVALID_DOCUMENT";
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_OCR_LOW_QUALITY = 4;
   */ ExtractionErrorType[ExtractionErrorType["OCR_LOW_QUALITY"] = 4] = "OCR_LOW_QUALITY";
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_NO_CONTENT = 5;
   */ ExtractionErrorType[ExtractionErrorType["NO_CONTENT"] = 5] = "NO_CONTENT";
    /**
   * @generated from enum value: EXTRACTION_ERROR_TYPE_HTTP = 6;
   */ ExtractionErrorType[ExtractionErrorType["HTTP"] = 6] = "HTTP";
    return ExtractionErrorType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExtractionErrorType)
proto3.util.setEnumType(ExtractionErrorType, "mono.capability.v1.ExtractionErrorType", [
    {
        no: 0,
        name: "EXTRACTION_ERROR_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXTRACTION_ERROR_TYPE_LLM"
    },
    {
        no: 2,
        name: "EXTRACTION_ERROR_TYPE_TIMEOUT"
    },
    {
        no: 3,
        name: "EXTRACTION_ERROR_TYPE_INVALID_DOCUMENT"
    },
    {
        no: 4,
        name: "EXTRACTION_ERROR_TYPE_OCR_LOW_QUALITY"
    },
    {
        no: 5,
        name: "EXTRACTION_ERROR_TYPE_NO_CONTENT"
    },
    {
        no: 6,
        name: "EXTRACTION_ERROR_TYPE_HTTP"
    }
]);
/**
 * @generated from message mono.capability.v1.CreateCapabilityRequest
 */ export class CreateCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.capability.v1.CapabilityType capability_type = 2;
   */ _define_property(this, "capabilityType", 0), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated mono.capability.v1.SourceDocument source_documents = 5;
   */ _define_property(this, "sourceDocuments", []), /**
   * @generated from field: repeated string skills = 6;
   */ _define_property(this, "skills", []), /**
   * @generated from field: repeated string certifications = 7;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: repeated string naics_codes = 8;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string contract_types = 9;
   */ _define_property(this, "contractTypes", []), /**
   * @generated from field: repeated string agencies = 10;
   */ _define_property(this, "agencies", []), /**
   * @generated from field: mono.capability.v1.PastPerformanceProof past_performance_proof = 11;
   */ _define_property(this, "pastPerformanceProof", void 0), /**
   * @generated from field: repeated string tags = 13;
   */ _define_property(this, "tags", []), /**
   * @generated from field: google.protobuf.Struct metadata = 14;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCapabilityRequest, "runtime", proto3);
_define_property(CreateCapabilityRequest, "typeName", "mono.capability.v1.CreateCapabilityRequest");
_define_property(CreateCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_type",
            kind: "enum",
            T: proto3.getEnumType(CapabilityType)
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_documents",
            kind: "message",
            T: SourceDocument,
            repeated: true
        },
        {
            no: 6,
            name: "skills",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "contract_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "agencies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "past_performance_proof",
            kind: "message",
            T: PastPerformanceProof
        },
        {
            no: 13,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.capability.v1.CreateCapabilityResponse
 */ export class CreateCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCapabilityResponse, "runtime", proto3);
_define_property(CreateCapabilityResponse, "typeName", "mono.capability.v1.CreateCapabilityResponse");
_define_property(CreateCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetCapabilityRequest
 */ export class GetCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapabilityRequest, "runtime", proto3);
_define_property(GetCapabilityRequest, "typeName", "mono.capability.v1.GetCapabilityRequest");
_define_property(GetCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetCapabilityResponse
 */ export class GetCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.capability.v1.CompanyCapability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapabilityResponse, "runtime", proto3);
_define_property(GetCapabilityResponse, "typeName", "mono.capability.v1.GetCapabilityResponse");
_define_property(GetCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: CompanyCapability
        }
    ]));
/**
 * @generated from message mono.capability.v1.ListCapabilitiesRequest
 */ export class ListCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * Filter by types
   *
   * @generated from field: repeated mono.capability.v1.CapabilityType capability_types = 2;
   */ _define_property(this, "capabilityTypes", []), /**
   * Filter by tags
   *
   * @generated from field: repeated string tags = 3;
   */ _define_property(this, "tags", []), /**
   * Only return verified capabilities
   *
   * @generated from field: bool verified_only = 4;
   */ _define_property(this, "verifiedOnly", false), /**
   * Pagination limit
   *
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0), /**
   * Pagination offset
   *
   * @generated from field: int32 offset = 6;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilitiesRequest, "runtime", proto3);
_define_property(ListCapabilitiesRequest, "typeName", "mono.capability.v1.ListCapabilitiesRequest");
_define_property(ListCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capability_types",
            kind: "enum",
            T: proto3.getEnumType(CapabilityType),
            repeated: true
        },
        {
            no: 3,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "verified_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.ListCapabilitiesResponse
 */ export class ListCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.capability.v1.CompanyCapability capabilities = 1;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilitiesResponse, "runtime", proto3);
_define_property(ListCapabilitiesResponse, "typeName", "mono.capability.v1.ListCapabilitiesResponse");
_define_property(ListCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capabilities",
            kind: "message",
            T: CompanyCapability,
            repeated: true
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * UpdateCapabilityRequest allows editing user-facing fields only.
 * System-managed fields (is_verified, quality_score) are updated via
 * dedicated RPCs or the extraction pipeline — not exposed here.
 *
 * @generated from message mono.capability.v1.UpdateCapabilityRequest
 */ export class UpdateCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated string skills = 4;
   */ _define_property(this, "skills", []), /**
   * @generated from field: repeated string certifications = 5;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: repeated string tags = 6;
   */ _define_property(this, "tags", []), /**
   * @generated from field: google.protobuf.Struct metadata = 7;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCapabilityRequest, "runtime", proto3);
_define_property(UpdateCapabilityRequest, "typeName", "mono.capability.v1.UpdateCapabilityRequest");
_define_property(UpdateCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "skills",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.capability.v1.UpdateCapabilityResponse
 */ export class UpdateCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCapabilityResponse, "runtime", proto3);
_define_property(UpdateCapabilityResponse, "typeName", "mono.capability.v1.UpdateCapabilityResponse");
_define_property(UpdateCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.DeleteCapabilityRequest
 */ export class DeleteCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapabilityRequest, "runtime", proto3);
_define_property(DeleteCapabilityRequest, "typeName", "mono.capability.v1.DeleteCapabilityRequest");
_define_property(DeleteCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Empty response — successful RPC implies success; failures use Connect status codes.
 *
 * @generated from message mono.capability.v1.DeleteCapabilityResponse
 */ export class DeleteCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapabilityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapabilityResponse, "runtime", proto3);
_define_property(DeleteCapabilityResponse, "typeName", "mono.capability.v1.DeleteCapabilityResponse");
_define_property(DeleteCapabilityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.capability.v1.EnsureVendorLibraryProjectRequest
 */ export class EnsureVendorLibraryProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureVendorLibraryProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureVendorLibraryProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureVendorLibraryProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureVendorLibraryProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureVendorLibraryProjectRequest, "runtime", proto3);
_define_property(EnsureVendorLibraryProjectRequest, "typeName", "mono.capability.v1.EnsureVendorLibraryProjectRequest");
_define_property(EnsureVendorLibraryProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.EnsureVendorLibraryProjectResponse
 */ export class EnsureVendorLibraryProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureVendorLibraryProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureVendorLibraryProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureVendorLibraryProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureVendorLibraryProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string project_name = 2;
   */ _define_property(this, "projectName", ""), /**
   * True if newly created, false if existed
   *
   * @generated from field: bool was_created = 3;
   */ _define_property(this, "wasCreated", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureVendorLibraryProjectResponse, "runtime", proto3);
_define_property(EnsureVendorLibraryProjectResponse, "typeName", "mono.capability.v1.EnsureVendorLibraryProjectResponse");
_define_property(EnsureVendorLibraryProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "was_created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.CreateCapabilityMatchRequest
 */ export class CreateCapabilityMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCapabilityMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCapabilityMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCapabilityMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCapabilityMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: repeated mono.capability.v1.MatchedCapability matched_capabilities = 4;
   */ _define_property(this, "matchedCapabilities", []), /**
   * @generated from field: double overall_match_score = 5;
   */ _define_property(this, "overallMatchScore", 0), /**
   * @generated from field: bool has_gap = 6;
   */ _define_property(this, "hasGap", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCapabilityMatchRequest, "runtime", proto3);
_define_property(CreateCapabilityMatchRequest, "typeName", "mono.capability.v1.CreateCapabilityMatchRequest");
_define_property(CreateCapabilityMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "matched_capabilities",
            kind: "message",
            T: MatchedCapability,
            repeated: true
        },
        {
            no: 5,
            name: "overall_match_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "has_gap",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.CreateCapabilityMatchResponse
 */ export class CreateCapabilityMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCapabilityMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCapabilityMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCapabilityMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCapabilityMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCapabilityMatchResponse, "runtime", proto3);
_define_property(CreateCapabilityMatchResponse, "typeName", "mono.capability.v1.CreateCapabilityMatchResponse");
_define_property(CreateCapabilityMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.RunCapabilityMatchRequest
 */ export class RunCapabilityMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new RunCapabilityMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunCapabilityMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunCapabilityMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunCapabilityMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunCapabilityMatchRequest, "runtime", proto3);
_define_property(RunCapabilityMatchRequest, "typeName", "mono.capability.v1.RunCapabilityMatchRequest");
_define_property(RunCapabilityMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.RunCapabilityMatchResponse
 */ export class RunCapabilityMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new RunCapabilityMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunCapabilityMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunCapabilityMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunCapabilityMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 requirements_matched = 1;
   */ _define_property(this, "requirementsMatched", 0), /**
   * @generated from field: int32 requirements_failed = 2;
   */ _define_property(this, "requirementsFailed", 0), /**
   * @generated from field: mono.capability.v1.GapAnalysisSummary gap_summary = 3;
   */ _define_property(this, "gapSummary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunCapabilityMatchResponse, "runtime", proto3);
_define_property(RunCapabilityMatchResponse, "typeName", "mono.capability.v1.RunCapabilityMatchResponse");
_define_property(RunCapabilityMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "requirements_failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "gap_summary",
            kind: "message",
            T: GapAnalysisSummary
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetCapabilityGapAnalysisRequest
 */ export class GetCapabilityGapAnalysisRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCapabilityGapAnalysisRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapabilityGapAnalysisRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapabilityGapAnalysisRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapabilityGapAnalysisRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * Optional filter
   *
   * @generated from field: repeated string requirement_ids = 3;
   */ _define_property(this, "requirementIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapabilityGapAnalysisRequest, "runtime", proto3);
_define_property(GetCapabilityGapAnalysisRequest, "typeName", "mono.capability.v1.GetCapabilityGapAnalysisRequest");
_define_property(GetCapabilityGapAnalysisRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetCapabilityGapAnalysisResponse
 */ export class GetCapabilityGapAnalysisResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCapabilityGapAnalysisResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapabilityGapAnalysisResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapabilityGapAnalysisResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapabilityGapAnalysisResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.capability.v1.RequirementMatch matches = 1;
   */ _define_property(this, "matches", []), /**
   * @generated from field: mono.capability.v1.GapAnalysisSummary gap_summary = 2;
   */ _define_property(this, "gapSummary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapabilityGapAnalysisResponse, "runtime", proto3);
_define_property(GetCapabilityGapAnalysisResponse, "typeName", "mono.capability.v1.GetCapabilityGapAnalysisResponse");
_define_property(GetCapabilityGapAnalysisResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "matches",
            kind: "message",
            T: RequirementMatch,
            repeated: true
        },
        {
            no: 2,
            name: "gap_summary",
            kind: "message",
            T: GapAnalysisSummary
        }
    ]));
/**
 * @generated from message mono.capability.v1.RequirementMatch
 */ export class RequirementMatch extends Message {
    static fromBinary(bytes, options) {
        return new RequirementMatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementMatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementMatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementMatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: string requirement_text = 2;
   */ _define_property(this, "requirementText", ""), /**
   * @generated from field: mono.capability.v1.ObligationStrength obligation_strength = 3;
   */ _define_property(this, "obligationStrength", 0), /**
   * @generated from field: repeated mono.capability.v1.MatchedCapability matched_capabilities = 4;
   */ _define_property(this, "matchedCapabilities", []), /**
   * @generated from field: double overall_match_score = 5;
   */ _define_property(this, "overallMatchScore", 0), /**
   * @generated from field: bool has_gap = 6;
   */ _define_property(this, "hasGap", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementMatch, "runtime", proto3);
_define_property(RequirementMatch, "typeName", "mono.capability.v1.RequirementMatch");
_define_property(RequirementMatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "requirement_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "obligation_strength",
            kind: "enum",
            T: proto3.getEnumType(ObligationStrength)
        },
        {
            no: 4,
            name: "matched_capabilities",
            kind: "message",
            T: MatchedCapability,
            repeated: true
        },
        {
            no: 5,
            name: "overall_match_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "has_gap",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.MatchedCapability
 */ export class MatchedCapability extends Message {
    static fromBinary(bytes, options) {
        return new MatchedCapability().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchedCapability().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchedCapability().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchedCapability, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * 0-100
   *
   * @generated from field: double match_score = 2;
   */ _define_property(this, "matchScore", 0), /**
   * @generated from field: string justification = 3;
   */ _define_property(this, "justification", ""), /**
   * @generated from field: repeated string evidence_excerpts = 4;
   */ _define_property(this, "evidenceExcerpts", []), /**
   * @generated from field: repeated string gaps = 5;
   */ _define_property(this, "gaps", []), /**
   * @generated from field: repeated string recommended_actions = 6;
   */ _define_property(this, "recommendedActions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchedCapability, "runtime", proto3);
_define_property(MatchedCapability, "typeName", "mono.capability.v1.MatchedCapability");
_define_property(MatchedCapability, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "match_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "justification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "evidence_excerpts",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "gaps",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "recommended_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.capability.v1.GapAnalysisSummary
 */ export class GapAnalysisSummary extends Message {
    static fromBinary(bytes, options) {
        return new GapAnalysisSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GapAnalysisSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GapAnalysisSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GapAnalysisSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_requirements = 1;
   */ _define_property(this, "totalRequirements", 0), /**
   * Score >= 80
   *
   * @generated from field: int32 fully_matched = 2;
   */ _define_property(this, "fullyMatched", 0), /**
   * Score 50-79
   *
   * @generated from field: int32 partially_matched = 3;
   */ _define_property(this, "partiallyMatched", 0), /**
   * Score < 50
   *
   * @generated from field: int32 not_matched = 4;
   */ _define_property(this, "notMatched", 0), /**
   * MUST requirements with score < 70
   *
   * @generated from field: int32 critical_gaps = 5;
   */ _define_property(this, "criticalGaps", 0), /**
   * @generated from field: repeated string capabilities_needed = 6;
   */ _define_property(this, "capabilitiesNeeded", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GapAnalysisSummary, "runtime", proto3);
_define_property(GapAnalysisSummary, "typeName", "mono.capability.v1.GapAnalysisSummary");
_define_property(GapAnalysisSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "fully_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "partially_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "not_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "critical_gaps",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "capabilities_needed",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.capability.v1.SubmitMatchFeedbackRequest
 */ export class SubmitMatchFeedbackRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitMatchFeedbackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitMatchFeedbackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitMatchFeedbackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitMatchFeedbackRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: mono.capability.v1.FeedbackRating rating = 3;
   */ _define_property(this, "rating", 0), /**
   * Optional
   *
   * @generated from field: string comment = 4;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string requirement_id = 6;
   */ _define_property(this, "requirementId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitMatchFeedbackRequest, "runtime", proto3);
_define_property(SubmitMatchFeedbackRequest, "typeName", "mono.capability.v1.SubmitMatchFeedbackRequest");
_define_property(SubmitMatchFeedbackRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rating",
            kind: "enum",
            T: proto3.getEnumType(FeedbackRating)
        },
        {
            no: 4,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.SubmitMatchFeedbackResponse
 */ export class SubmitMatchFeedbackResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitMatchFeedbackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitMatchFeedbackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitMatchFeedbackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitMatchFeedbackResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string feedback_id = 1;
   */ _define_property(this, "feedbackId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitMatchFeedbackResponse, "runtime", proto3);
_define_property(SubmitMatchFeedbackResponse, "typeName", "mono.capability.v1.SubmitMatchFeedbackResponse");
_define_property(SubmitMatchFeedbackResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "feedback_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetMatchQualityMetricsRequest
 */ export class GetMatchQualityMetricsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchQualityMetricsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchQualityMetricsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchQualityMetricsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchQualityMetricsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchQualityMetricsRequest, "runtime", proto3);
_define_property(GetMatchQualityMetricsRequest, "typeName", "mono.capability.v1.GetMatchQualityMetricsRequest");
_define_property(GetMatchQualityMetricsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetMatchQualityMetricsResponse
 */ export class GetMatchQualityMetricsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchQualityMetricsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchQualityMetricsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchQualityMetricsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchQualityMetricsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_matches = 1;
   */ _define_property(this, "totalMatches", 0), /**
   * @generated from field: int32 helpful_count = 2;
   */ _define_property(this, "helpfulCount", 0), /**
   * @generated from field: int32 not_helpful_count = 3;
   */ _define_property(this, "notHelpfulCount", 0), /**
   * @generated from field: int32 irrelevant_count = 4;
   */ _define_property(this, "irrelevantCount", 0), /**
   * @generated from field: int32 no_feedback_count = 5;
   */ _define_property(this, "noFeedbackCount", 0), /**
   * @generated from field: double helpful_percentage = 6;
   */ _define_property(this, "helpfulPercentage", 0), /**
   * @generated from field: repeated mono.capability.v1.FeedbackBreakdown breakdown_by_project = 7;
   */ _define_property(this, "breakdownByProject", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchQualityMetricsResponse, "runtime", proto3);
_define_property(GetMatchQualityMetricsResponse, "typeName", "mono.capability.v1.GetMatchQualityMetricsResponse");
_define_property(GetMatchQualityMetricsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "helpful_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "not_helpful_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "irrelevant_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "no_feedback_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "helpful_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "breakdown_by_project",
            kind: "message",
            T: FeedbackBreakdown,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.capability.v1.FeedbackBreakdown
 */ export class FeedbackBreakdown extends Message {
    static fromBinary(bytes, options) {
        return new FeedbackBreakdown().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeedbackBreakdown().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeedbackBreakdown().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FeedbackBreakdown, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string project_name = 2;
   */ _define_property(this, "projectName", ""), /**
   * @generated from field: int32 total_matches = 3;
   */ _define_property(this, "totalMatches", 0), /**
   * @generated from field: int32 helpful_count = 4;
   */ _define_property(this, "helpfulCount", 0), /**
   * @generated from field: double helpful_percentage = 5;
   */ _define_property(this, "helpfulPercentage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FeedbackBreakdown, "runtime", proto3);
_define_property(FeedbackBreakdown, "typeName", "mono.capability.v1.FeedbackBreakdown");
_define_property(FeedbackBreakdown, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "helpful_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "helpful_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.RecordExtractionMetricsRequest
 */ export class RecordExtractionMetricsRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordExtractionMetricsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordExtractionMetricsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordExtractionMetricsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordExtractionMetricsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vendor_document_id = 1;
   */ _define_property(this, "vendorDocumentId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * Freeform: "RESUME", "CASE_STUDY", "PAST_PERFORMANCE", etc. String (not enum) because Baltigo returns arbitrary format strings that may expand.
   *
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: mono.capability.v1.ExtractionStatus status = 4;
   */ _define_property(this, "status", 0), /**
   * @generated from field: int32 capabilities_found = 5;
   */ _define_property(this, "capabilitiesFound", 0), /**
   * 0-1
   *
   * @generated from field: double average_confidence = 6;
   */ _define_property(this, "averageConfidence", 0), /**
   * @generated from field: double duration_seconds = 7;
   */ _define_property(this, "durationSeconds", 0), /**
   * @generated from field: string error_message = 8;
   */ _define_property(this, "errorMessage", ""), /**
   * @generated from field: mono.capability.v1.ExtractionErrorType error_type = 9;
   */ _define_property(this, "errorType", 0), /**
   * @generated from field: double ocr_confidence = 10;
   */ _define_property(this, "ocrConfidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordExtractionMetricsRequest, "runtime", proto3);
_define_property(RecordExtractionMetricsRequest, "typeName", "mono.capability.v1.RecordExtractionMetricsRequest");
_define_property(RecordExtractionMetricsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vendor_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ExtractionStatus)
        },
        {
            no: 5,
            name: "capabilities_found",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "average_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "duration_seconds",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "error_type",
            kind: "enum",
            T: proto3.getEnumType(ExtractionErrorType)
        },
        {
            no: 10,
            name: "ocr_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.RecordExtractionMetricsResponse
 */ export class RecordExtractionMetricsResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordExtractionMetricsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordExtractionMetricsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordExtractionMetricsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordExtractionMetricsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string metric_id = 1;
   */ _define_property(this, "metricId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordExtractionMetricsResponse, "runtime", proto3);
_define_property(RecordExtractionMetricsResponse, "typeName", "mono.capability.v1.RecordExtractionMetricsResponse");
_define_property(RecordExtractionMetricsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metric_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetExtractionDashboardRequest
 */ export class GetExtractionDashboardRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExtractionDashboardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExtractionDashboardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExtractionDashboardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExtractionDashboardRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExtractionDashboardRequest, "runtime", proto3);
_define_property(GetExtractionDashboardRequest, "typeName", "mono.capability.v1.GetExtractionDashboardRequest");
_define_property(GetExtractionDashboardRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.GetExtractionDashboardResponse
 */ export class GetExtractionDashboardResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExtractionDashboardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExtractionDashboardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExtractionDashboardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExtractionDashboardResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.capability.v1.ExtractionStats stats = 1;
   */ _define_property(this, "stats", void 0), /**
   * @generated from field: repeated mono.capability.v1.ErrorBreakdown error_breakdown = 2;
   */ _define_property(this, "errorBreakdown", []), /**
   * @generated from field: repeated mono.capability.v1.DocumentTypeStats document_type_stats = 3;
   */ _define_property(this, "documentTypeStats", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExtractionDashboardResponse, "runtime", proto3);
_define_property(GetExtractionDashboardResponse, "typeName", "mono.capability.v1.GetExtractionDashboardResponse");
_define_property(GetExtractionDashboardResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stats",
            kind: "message",
            T: ExtractionStats
        },
        {
            no: 2,
            name: "error_breakdown",
            kind: "message",
            T: ErrorBreakdown,
            repeated: true
        },
        {
            no: 3,
            name: "document_type_stats",
            kind: "message",
            T: DocumentTypeStats,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.capability.v1.ExtractionStats
 */ export class ExtractionStats extends Message {
    static fromBinary(bytes, options) {
        return new ExtractionStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractionStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractionStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractionStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_extractions = 1;
   */ _define_property(this, "totalExtractions", 0), /**
   * @generated from field: int32 successful = 2;
   */ _define_property(this, "successful", 0), /**
   * @generated from field: int32 failed = 3;
   */ _define_property(this, "failed", 0), /**
   * @generated from field: int32 low_confidence = 4;
   */ _define_property(this, "lowConfidence", 0), /**
   * @generated from field: double success_rate = 5;
   */ _define_property(this, "successRate", 0), /**
   * @generated from field: double average_confidence = 6;
   */ _define_property(this, "averageConfidence", 0), /**
   * @generated from field: double average_duration_seconds = 7;
   */ _define_property(this, "averageDurationSeconds", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractionStats, "runtime", proto3);
_define_property(ExtractionStats, "typeName", "mono.capability.v1.ExtractionStats");
_define_property(ExtractionStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_extractions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "successful",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "low_confidence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "success_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "average_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "average_duration_seconds",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.ErrorBreakdown
 */ export class ErrorBreakdown extends Message {
    static fromBinary(bytes, options) {
        return new ErrorBreakdown().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ErrorBreakdown().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ErrorBreakdown().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ErrorBreakdown, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string error_type = 1;
   */ _define_property(this, "errorType", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0), /**
   * @generated from field: double percentage = 3;
   */ _define_property(this, "percentage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ErrorBreakdown, "runtime", proto3);
_define_property(ErrorBreakdown, "typeName", "mono.capability.v1.ErrorBreakdown");
_define_property(ErrorBreakdown, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "error_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.DocumentTypeStats
 */ export class DocumentTypeStats extends Message {
    static fromBinary(bytes, options) {
        return new DocumentTypeStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentTypeStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentTypeStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentTypeStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_type = 1;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 successful = 3;
   */ _define_property(this, "successful", 0), /**
   * @generated from field: double success_rate = 4;
   */ _define_property(this, "successRate", 0), /**
   * @generated from field: double average_confidence = 5;
   */ _define_property(this, "averageConfidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentTypeStats, "runtime", proto3);
_define_property(DocumentTypeStats, "typeName", "mono.capability.v1.DocumentTypeStats");
_define_property(DocumentTypeStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "successful",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "success_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "average_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.CompanyCapability
 */ export class CompanyCapability extends Message {
    static fromBinary(bytes, options) {
        return new CompanyCapability().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyCapability().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyCapability().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyCapability, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.capability.v1.CapabilityType capability_type = 3;
   */ _define_property(this, "capabilityType", 0), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated mono.capability.v1.SourceDocument source_documents = 6;
   */ _define_property(this, "sourceDocuments", []), /**
   * @generated from field: repeated string skills = 7;
   */ _define_property(this, "skills", []), /**
   * @generated from field: repeated string certifications = 8;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: repeated string naics_codes = 9;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string contract_types = 10;
   */ _define_property(this, "contractTypes", []), /**
   * @generated from field: repeated string agencies = 11;
   */ _define_property(this, "agencies", []), /**
   * @generated from field: mono.capability.v1.PastPerformanceProof past_performance_proof = 12;
   */ _define_property(this, "pastPerformanceProof", void 0), /**
   * @generated from field: bool is_verified = 13;
   */ _define_property(this, "isVerified", false), /**
   * @generated from field: int32 quality_score = 14;
   */ _define_property(this, "qualityScore", 0), /**
   * @generated from field: google.protobuf.Timestamp last_extracted = 15;
   */ _define_property(this, "lastExtracted", void 0), /**
   * @generated from field: string extracted_by = 16;
   */ _define_property(this, "extractedBy", ""), /**
   * @generated from field: repeated string tags = 17;
   */ _define_property(this, "tags", []), /**
   * @generated from field: google.protobuf.Struct metadata = 18;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 19;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyCapability, "runtime", proto3);
_define_property(CompanyCapability, "typeName", "mono.capability.v1.CompanyCapability");
_define_property(CompanyCapability, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capability_type",
            kind: "enum",
            T: proto3.getEnumType(CapabilityType)
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_documents",
            kind: "message",
            T: SourceDocument,
            repeated: true
        },
        {
            no: 7,
            name: "skills",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "contract_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "agencies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "past_performance_proof",
            kind: "message",
            T: PastPerformanceProof
        },
        {
            no: 13,
            name: "is_verified",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "quality_score",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "last_extracted",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "extracted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 18,
            name: "metadata",
            kind: "message",
            T: Struct
        },
        {
            no: 19,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.capability.v1.SourceDocument
 */ export class SourceDocument extends Message {
    static fromBinary(bytes, options) {
        return new SourceDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vendor_document_id = 1;
   */ _define_property(this, "vendorDocumentId", ""), /**
   * @generated from field: string document_title = 2;
   */ _define_property(this, "documentTitle", ""), /**
   * @generated from field: repeated string excerpts = 3;
   */ _define_property(this, "excerpts", []), /**
   * @generated from field: double confidence = 4;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceDocument, "runtime", proto3);
_define_property(SourceDocument, "typeName", "mono.capability.v1.SourceDocument");
_define_property(SourceDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vendor_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "excerpts",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.PastPerformanceProof
 */ export class PastPerformanceProof extends Message {
    static fromBinary(bytes, options) {
        return new PastPerformanceProof().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PastPerformanceProof().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PastPerformanceProof().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PastPerformanceProof, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: double contract_value = 2;
   */ _define_property(this, "contractValue", 0), /**
   * @generated from field: string performance_period = 3;
   */ _define_property(this, "performancePeriod", ""), /**
   * @generated from field: string client_name = 4;
   */ _define_property(this, "clientName", ""), /**
   * @generated from field: string project_description = 5;
   */ _define_property(this, "projectDescription", ""), /**
   * @generated from field: repeated string key_outcomes = 6;
   */ _define_property(this, "keyOutcomes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PastPerformanceProof, "runtime", proto3);
_define_property(PastPerformanceProof, "typeName", "mono.capability.v1.PastPerformanceProof");
_define_property(PastPerformanceProof, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "performance_period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "client_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "key_outcomes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
